module.exports = __webpack_public_path__ + "img/aeroland-tab-content-image-04.84abf174.png";